import { render, staticRenderFns } from "./GroundNews.vue?vue&type=template&id=4ef9695d&scoped=true&"
import script from "./GroundNews.vue?vue&type=script&lang=js&"
export * from "./GroundNews.vue?vue&type=script&lang=js&"
import style0 from "./GroundNews.vue?vue&type=style&index=0&id=4ef9695d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9695d",
  null
  
)

export default component.exports